import { collection, query, orderBy, limit, getDocs } from "firebase/firestore";
import { firestore } from "../firebase";
import { TrackData } from "../types/Types";

export const RecentlyAddedService = {

    async getRecentlyAddedTracks(): Promise<TrackData[]> {
        try {
            const tracksRef = collection(firestore, "trackLinks");

            const q = query(
                tracksRef,
                orderBy("createdAt", "desc"),
                limit(20)
            );

            const querySnapshot = await getDocs(q);

            const tracks: TrackData[] = querySnapshot.docs.map((doc) => {
                const data = doc.data();

                return {
                    id: doc.id,
                    userId: data.userId || "",
                    coverArtUrl: data.coverArtUrl || "",
                    trackTitle: data.trackTitle || "Unknown Title",
                    artistName: data.artistName || "Unknown Artist",
                    featureArtists: data.featureArtists || [],
                    genreName: data.genreName || "",
                    releaseType: data.releaseType || "",
                    platformLinks: data.platformLinks || {},
                    moodTags: data.moodTags || [],
                    stateID: data.stateID || 0,
                    regionID: data.regionID || 0,
                    releaseDate: data.releaseDate?.toDate() || null,
                } as TrackData;
            });

            return tracks;
        } catch (error) {
            console.error("Error fetching recently added tracks:", error);
            return [];
        }
    }
};